import { Reveal } from "../lib/motion";
import { GALLERY } from "../lib/data";
import { LocalImage } from "./LocalImage";

export const Gallery = () => (
  <section id="galerie" data-testid="gallery-section" className="relative py-20 md:py-28 lg:py-36 bg-brand-dark">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <Reveal>
        <p className="section-eyebrow"><span /> Einblicke</p>
        <h2 className="section-heading">Projekte & Impressionen</h2>
        <p className="mt-5 text-white/60 max-w-xl leading-relaxed">
          Am Fahrzeug, in der Werkstatt und direkt am Steuergerät. Aufnahmen aus unserem Arbeitsalltag.
        </p>
      </Reveal>
      <div className="gallery-grid grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4 mt-10 md:mt-14">
        {GALLERY.map((item, i) => (
          <Reveal key={item.src} delay={(i % 3) * 0.05}
            className={`${item.tall ? "row-span-2" : ""} min-w-0 overflow-hidden border border-slate-800`}>
            <figure className="gallery-photo group relative w-full h-full overflow-hidden bg-brand-surface" data-testid={`gallery-item-${i}`}>
              <LocalImage src={item.src} alt={item.alt} style={{ objectPosition: item.position || "center" }}
                className="w-full h-full object-cover transition-[filter,transform] duration-700" />
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 to-transparent px-3 sm:px-5 pt-12 pb-4">
                <span className="font-mono text-[9px] sm:text-[11px] uppercase tracking-wider text-white/80">{item.label}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
